module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00539.7dfdf5e6.jpg";